const photoEnhancer = {
  UnlimitedNumberOfSheets: 'Unlimited number of images',
  SupportAllModels: 'Supports todo os models',
  MagnificationAllX: 'Magnification: 1X, 2X, 4X, 8X',
  OutputImageFormatMore: 'Output image format: JPG, PNG, TIFF',
  NoWatermark: 'No watermark',
  CancelAtAnytime: 'Cancel at any time',
  HighPriorityProcessingSpeed: 'High priority processing speed',
  HitPawAIPhotoEnhancer: 'HitPaw AI Photo Enhancer',
  weekDayPrice: '$1.28',
  WeekTotalPrice: '$8.99',
  MonthDayPrice: '$0.63',
  MonthTotalPrice: '$18.99',
  YearDayPrice: '$0.36',
  YearTotalPrice: '$129.99',
  Day: 'Day',
  Monthly: 'Monthly',
  Weekly: 'Weekly',
  Yearly: 'Yearly',
};

export default photoEnhancer;
